module.exports = __webpack_public_path__ + "img/icon-settlement@2x.1e7a8bd5.png";